<template>
  <div class="rounded-lg shadow-xl p-10 my-10">
    <div class="flex items-center justify-between">
      <h1 class="font-bold text-2xl">Events</h1>
      <div class="p-2 lg:p-3 bg-buttoncolor rounded-lg">
        <i class="fas fa-2x fa-arrow-right text-white"></i>
      </div>
    </div>
    <VSPagination>
      <template #data="{}">
        <c-spinner
          v-if="!predictions.length"
          thickness="4px"
          speed="0.65s"
          empty-color="blue.200"
          color="blue.500"
          size="xl"
          class="flex m-auto justify-center"
        />

        <div class="my-10 table-responsive">
          <table class="table-fixed lg:w-full tableClass">
            <thead>
              <tr>
                <th>Images</th>
                <!-- <th>Description</th> -->
                <th>Threat</th>
                <th>Status</th>
                <th>Date/Time</th>
                <th>Meta</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, i) in predictions"
                :key="i"
                @click="click(data._id)"
                class="hover:bg-btnGray rounded-lg cursor-pointer"
              >
                <!-- <router-link :to="`/event/${data._id}`"> -->
                <td>
                  <img
                    :src="`${data.image}`"
                    alt=""
                    width="150px"
                    height="150px"
                    @click="open(data.image)"
                    class="eventImage"
                  />
                </td>
                <!-- <td>
                  {{ data.classes | changToString }}
                  {{ data.description }}
                </td> -->
                <td>{{ data.threat }}</td>
                <td class="body_link">
                  {{ data.status }}
                </td>
                <td>
                  <!-- 4:20pm <br /> -->
                  {{ data.prediction_time }}
                  <!-- 10-12-2020 -->
                </td>
                <td>GPS location: 41°24'12.2"N 2°10'26.5"E <br /></td>
              </tr>
            </tbody>
          </table>

          <c-modal
            :is-open="isOpen"
            :on-close="close"
            is-centered
            :closeOnOverlayClick="true"
            size="xl"
          >
            <c-modal-content ref="content">
              <c-modal-header>Single Image</c-modal-header>
              <c-modal-close-button />
              <c-modal-body>
                <img :src="`${modalImage}`" alt="" />
              </c-modal-body>
            </c-modal-content>
            <c-modal-overlay />
          </c-modal>
        </div>
      </template>
    </VSPagination>
  </div>
</template>

<script>
import VSPagination from "@/components/VSPagination.vue";
import Pusher from "pusher-js";
import {
  CModal,
  CModalOverlay,
  CModalContent,
  CModalHeader,
  CModalBody,
  CModalCloseButton
} from "@chakra-ui/vue";
import { CSpinner } from "@chakra-ui/vue";
import { mapGetters } from "vuex";
export default {
  props: ["pageNumber"],
  data() {
    return {
      predictionResponse: null,
      dataTable: [],
      arrToString: "",
      isOpen: false,
      modalImage: null
    };
  },
  components: {
    CSpinner,
    CModal,
    CModalOverlay,
    CModalContent,
    CModalHeader,
    // CModalFooter,
    CModalBody,
    CModalCloseButton,
    VSPagination
  },

  methods: {
    click(data) {
      this.$store.dispatch("events/clearPrediction");
      this.$store.dispatch("events/getPrediction", data);
      this.$router.push(`event/${data}`);
    },
    open(singleImage) {
      this.isOpen = true;
      this.modalImage = singleImage;
    },
    close() {
      this.isOpen = false;
    },
    pusherData() {
      console.log("Pusher");
      var pusher = new Pusher("c8ad5703cc985e1d2687", {
        cluster: "eu"
      });
      pusher.subscribe("spill-sat");
      pusher.bind("new-prediction", data => {
        console.log("An event was triggered");
        this.predictions.unshift(data);
        console.log(data);
      });
    }
  },

  filters: {
    changToString: function(value) {
      if (!value) return "";
      return (value = value.toString());
    },
    slicee(data) {
      let str = data.toString();
      let res = str.slice(68, 87);
      return res;
    }
  },
  created() {
    this.pusherData();
  },
  computed: {
    ...mapGetters({
      predictions: "events/predictions"
    })
  }
};
</script>

<style scoped>
thead tr {
  text-align: left;
  margin: 20px;
  font-size: 1.5em;
  color: #232949;
  font-weight: 500;
}
tbody tr td {
  border-top: solid grey 1px;
  color: grey;
  font-weight: 500;
}
.body_link {
  color: #00b1da;
}
.tableClass td {
  padding: 20px 10px;
}
.tableClass th {
  padding: 20px 10px;
}
.eventImage {
  height: 150px;
}
</style>
